import SellerLandingPage from '@/components/skus/SellerPage/SellerLandingPage';
import SkusEntirePage from '@/components/skus/SkusEntirePage';
import getSkusServerSideProps from '@/lib/serverSideProps/serverSidePropsPages/getSkusServerSideProps';
import { SellerPageProps, SkusServerProps } from '@/types/props/pages';

export default function SkuPage(props: SkusServerProps | SellerPageProps) {
  // A landing page tied to a seller lists that seller's shelf instead of the
  // catalogue grid (WEB-1322). `asks` is only present in that case.
  if ('asks' in props) {
    return <SellerLandingPage {...props} />;
  }

  return <SkusEntirePage {...props} />;
}

export const getServerSideProps = getSkusServerSideProps;
